module.exports = __webpack_public_path__ + "img/camera.0c815803.svg";